<template>
  <div id="app">
    <MobileHeader
      v-if="
        $route.name !== 'administration' &&
        $route.name !== 'administrationLogin' &&
        $route.name !== 'administrationNews' &&
        $route.name !== 'administrationAd' &&
        $route.name !== 'administrationAdEdit' &&
        $route.name !== 'administrationCareers' &&
        !($route.name === 'kcmGroup' && $route.query.page === 'companies')
      "
    />
    <router-view></router-view>
    <vue-snotify></vue-snotify>
    <Footer
      v-if="
        $route.name !== 'administration' &&
        $route.name !== 'administrationLogin' &&
        $route.name !== 'administrationNews' &&
        $route.name !== 'administrationAd' &&
        $route.name !== 'administrationAdEdit' &&
        $route.name !== 'administrationCareers' &&
        !($route.name === 'kcmGroup' && $route.query.page === 'companies')
      "
    />
    <GDPR />
  </div>
</template>

<script>
import MobileHeader from "./components/shared/MobileHeader";
import Footer from "./components/shared/Footer";
import GDPR from "./components/shared/GDPR";
export default {
  name: "app",
  components: {
    MobileHeader,
    Footer,
    GDPR,
  },
  watch: {
    $route() {
      window.scrollTo(0, 0);
    },
  },
  methods: {
    setVh() {
      // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
      let vh = window.innerHeight * 0.01;
      // Then we set the value in the --vh custom property to the root of the document
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    },
  },
  mounted() {
    this.setVh();
    // // We listen to the resize event
    // window.addEventListener("resize", () => {
    //   this.setVh();
    // });
  },
};
</script>

<style lang="scss">
@import "./assets/css/reset.css";
@import "~vue-snotify/styles/material";
@font-face {
  font-family: "Rubik";
  src: url("./assets/fonts/Rubik-Medium.woff2") format("woff2"),
    url("./assets/fonts/Rubik-Medium.woff") format("woff");
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: "Playfair Display";
  src: url("./assets/fonts/PlayfairDisplay-Black.woff2") format("woff2"),
    url("./assets/fonts/PlayfairDisplay-Black.woff") format("woff");
  font-weight: 900;
  font-style: normal;
}

@font-face {
  font-family: "Rubik";
  src: url("./assets/fonts/Rubik-Light.woff2") format("woff2"),
    url("./assets/fonts/Rubik-Light.woff") format("woff");
  font-weight: 300;
  font-style: normal;
}

@font-face {
  font-family: "Playfair Display";
  src: url("./assets/fonts/PlayfairDisplay-Regular.woff2") format("woff2"),
    url("./assets/fonts/PlayfairDisplay-Regular.woff") format("woff");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "Rubik";
  src: url("./assets/fonts/Rubik-Regular.woff2") format("woff2"),
    url("./assets/fonts/Rubik-Regular.woff") format("woff");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "Playfair Display";
  src: url("./assets/fonts/PlayfairDisplay-Bold.woff2") format("woff2"),
    url("./assets/fonts/PlayfairDisplay-Bold.woff") format("woff");
  font-weight: bold;
  font-style: normal;
}

@font-face {
  font-family: "Rubik";
  src: url("./assets/fonts/Rubik-Black.woff2") format("woff2"),
    url("./assets/fonts/Rubik-Black.woff") format("woff");
  font-weight: 900;
  font-style: normal;
}

@font-face {
  font-family: "Rubik";
  src: url("./assets/fonts/Rubik-Bold.woff2") format("woff2"),
    url("./assets/fonts/Rubik-Bold.woff") format("woff");
  font-weight: bold;
  font-style: normal;
}
/* Generated by Glyphter (http://www.glyphter.com) on  Fri Mar 01 2019*/
@font-face {
  font-family: "kcm";
  src: url("./assets/fonts/kcm.eot");
  src: url("./assets/fonts/kcm.eot?#iefix") format("embedded-opentype"),
    url("./assets/fonts/kcm.woff") format("woff"),
    url("./assets/fonts/kcm.ttf") format("truetype"),
    url("./assets/fonts/kcm.svg#kcm") format("svg");
  font-weight: normal;
  font-style: normal;
}
[class*="icon-"]:before {
  display: inline-block;
  font-family: "kcm";
  font-style: normal;
  font-weight: normal;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.icon-img-up:before {
  content: "\0041";
}
.icon-img-right:before {
  content: "\0042";
}
.icon-img-down:before {
  content: "\0043";
}
.icon-img-left:before {
  content: "\0044";
}
.icon-left:before {
  content: "\0045";
}
.icon-right:before {
  content: "\0046";
}
.icon-dd-up:before {
  content: "\0047";
}
.icon-dd-down:before {
  content: "\0048";
}
.icon-plus:before {
  content: "\0049";
}
.icon-cancel:before {
  content: "\004a";
}
.icon-img-full:before {
  content: "\004b";
}
.icon-img-window:before {
  content: "\004c";
}
.icon-menu:before {
  content: "\004d";
}
.icon-apps:before {
  content: "\004e";
}
.icon-search:before {
  content: "\004f";
}
.icon-lng:before {
  content: "\0050";
}
.icon-rotate:before {
  content: "\0051";
}
.icon-ok:before {
  content: "\0052";
}
.icon-menu2:before {
  content: "\0053";
}
.icon-line:before {
  content: "\0054";
}
.icon-kg:before {
  content: "\0055";
}
.icon-discuss-issue:before {
  content: "\0056";
}
.icon-facts:before {
  content: "\0057";
}
.icon-alloys:before {
  content: "\0058";
}
.icon-pdf-file:before {
  content: "\0059";
}
.icon-location:before {
  content: "\005a";
}
.kcm {
  font-family: "kcm";
}
html {
  font-size: 13px;
}
body {
  background-color: $bgColor4;
}
html,
body {
  height: 100%;
}
#app {
  font-family: "Rubik", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $mainText;
}
*,
*::before,
*::after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
textarea {
  font-family: "Rubik", Helvetica, Arial, sans-serif;
}
a {
  color: $mainText;
  cursor: pointer;
  text-decoration: none;
}
button {
  @include transition(all 0.3s);
  background-color: $mainColor3;
  border: none;
  color: #fff;
  cursor: pointer;
  font-family: "Rubik";
  font-size: 10px;
  font-weight: 700;
  height: 40px;
  outline: none;
  padding: 0 10px;
  text-transform: uppercase;
}
button:hover {
  opacity: 0.9;
}

// NEWS PREVIEW STYLING
.news-preview-paragraph p {
  font-size: 18px;
  line-height: 26px;
  text-align: left;
}
.news-preview-paragraph .ql-align-center {
  text-align: center;
}
.news-preview-paragraph .ql-align-right {
  text-align: right;
}
.news-preview-paragraph .ql-align-justify {
  text-align: justify;
}
.news-preview-paragraph li {
  font-size: 18px;
  line-height: 26px;
}
.news-preview-paragraph a {
  color: $mainColor;
  font-weight: 700;
  text-decoration: underline;
  @include transition(all 0.3s);
}
.news-preview-paragraph a:hover {
  opacity: 0.9;
}
.news-preview-paragraph iframe,
.ql-video {
  width: 100%;
  height: 30vw;
}

@media screen and (max-width: 1000px) {
  .news-preview-paragraph p {
    font-size: 13px;
    line-height: 18px;
  }

  .news-preview-paragraph li {
    font-size: 13px;
    line-height: 18px;
  }
}
@media screen and (max-width: 600px) {
  .news-preview-paragraph p {
    font-size: 12px;
    line-height: 16px;
  }

  .news-preview-paragraph li {
    font-size: 12px;
    line-height: 16px;
  }
}
/*
 CSS for the main interaction
*/
.accordion > input[name="collapse"] {
  display: none;

  /*position: absolute;
  left: -100vw;*/
}

.accordion label,
.accordion .content {
  /* max-width: 620px; */
  margin: 0 auto;
}

.accordion .content {
  overflow: hidden;
  height: 0;
  transition: 0.5s;
}

.accordion > input[name="collapse"]:checked ~ .content {
  /* height: 380px; */
  transition: height 0.5s;
}

.accordion label {
  display: block;
}

/* For Desktop */
@media only screen and (min-width: 620px) {
  .accordion > input[name="collapse"]:checked ~ .content {
    height: auto;
  }
}

.accordion {
  margin-bottom: 1em;
}

.accordion > input[name="collapse"]:checked ~ .content {
  border-top: 0;
  transition: 0.3s;
}

.accordion .handle {
  margin: 0;
  font-size: 16px;
}
.accordion label {
  color: #164194;
  text-decoration: underline;
  cursor: pointer;
  font-weight: bold;
  user-select: none;
}

.accordion label:hover,
.accordion label:focus {
  color: #1f88ff;
}
</style>
